import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { QR_TOKEN_KEY } from "@/lib/kioskApi";
import Kiosk from "@/pages/Kiosk";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// /t/:token — customer scans a table QR. The backend resolves venue + table and issues a trusted table session;
// the table can never come from the URL or from speech.
export default function TableQR() {
  const { token } = useParams();
  const [state, setState] = useState("loading");
  const [err, setErr] = useState("");
  useEffect(() => {
    sessionStorage.setItem("mm_qr_path", `/t/${token}`);
    const mine = sessionStorage.getItem("mm_qr_for");
    if (sessionStorage.getItem(QR_TOKEN_KEY) && mine === token) { setState("ready"); return; }
    sessionStorage.removeItem(QR_TOKEN_KEY);
    axios.post(`${API}/public/table-qr/${token}/session`)
      .then((r) => { sessionStorage.setItem(QR_TOKEN_KEY, r.data.token); sessionStorage.setItem("mm_qr_for", token); setState("ready"); })
      .catch((e) => { setErr(e?.response?.data?.detail || "This table code isn't working — please ask a team member."); setState("error"); });
  }, [token]);
  if (state === "error") return <div className="min-h-screen bg-[#0f2a3d] text-white flex items-center justify-center p-8 text-center text-xl" data-testid="table-qr-error">{err}</div>;
  if (state === "loading") return <div className="min-h-screen bg-[#0f2a3d]" data-testid="table-qr-loading" />;
  return <Kiosk />;
}
